import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Box, Grid } from "@material-ui/core";
import { client } from "../../service/ApolloClient/ApolloClient";
import { QUERY_USER } from "../../service/ApolloClient/ApolloQueries";
import { ErrorToast } from "../../hoc/ToastNotify/ToastNotify";
import { withRouter } from "react-router";
import PersonAddForm from "../../components/Person/Add/PersonAddForm";
import PersonListAttachment from "./PersonListAttachment";
import Loading from "../../components/UI/Loading/Loading";
import DebitCreditListUserPage from "../DebitCredit/DebitCreditListUserPage";
import BankAccountListUserPage from "../BankAccount/BankAccountListUserPage";
import ChequeList from "../../components/Cheque/List/ChequeList";
import ChequeSummaryTables from "../../components/Cheque/ChequeSummaryTables/ChequeSummaryTables";
import ChequeStatusCard from "../../components/Cheque/ChequeStatusCard/ChequeStatusCard";
import PersonAmar from "./PersonAmar";
import DebitCreditRowDetail from "../../components/DebitCredit/RowDetail";

export const PERSON_SELECT_EDIT = "PERSON_SELECT_EDIT";
export const PERSON_SELECT_ATTACHMENT = "PERSON_SELECT_ATTACHMENT";
export const PERSON_SELECT_CHEQUE_CONTRACT = "PERSON_SELECT_CHEQUE_CONTRACT";
export const PERSON_SELECT_CAR_CONTRACT = "PERSON_SELECT_CAR_CONTRACT";

class PersonEditPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.match.params.id,
      data: null,
      loading: true,
      pageSelect: PERSON_SELECT_EDIT,
      needUpdate: false,
      keyDebit: Math.random(),
      openDebit: null,
      keyRowDebit: Math.random(),
    };

    this.handleSelectPage = this.handleSelectPage.bind(this);
    this.handleReloadDebit = this.handleReloadDebit.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.match.params.id !== prevState.id) {
      return { ...prevState, needUpdate: true, id: nextProps.match.params.id };
    }

    // Return null to indicate no change to state.
    return null;
  }

  componentDidMount() {
    this.loadPage();
  }

  handleSelectPage = (page) => {
    this.setState({
      pageSelect: page,
    });
  };

  loadPage = () => {
    this.setState({
      loading: true,
      needUpdate: false,
    });

    client
      .query({
        query: QUERY_USER,
        variables: {
          id: parseInt(this.state.id),
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        let data = res.data.user;

        this.setState({
          loading: false,
          data: data,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
          data: null,
        });
        ErrorToast("مشکل در دریافت اطلاعات");
      });
  };

  handleReloadDebit() {
    this.setState({
      keyDebit: Math.random(),
      keyRowDebit: Math.random(),
    });
  }

  render() {
    if (this.state.needUpdate) {
      this.loadPage();
    }

    const { data, loading, pageSelect } = this.state;

    let componentSelect = <Loading />;

    if (pageSelect === PERSON_SELECT_EDIT && !loading) {
      componentSelect = (
        <Grid container={true}>
          <Grid item md={12}>
            <PersonAddForm
              handleSelectPage={this.handleSelectPage}
              data={data}
              handleReloadDebit={this.handleReloadDebit}
              isEdit={true}
              setOpenDebit={(e) => {
                this.setState({ openDebit: e });
              }}
            />
          </Grid>
          <Grid item md={12}>
            <Box mt={2} mb={2}>
              <ChequeStatusCard userId={data.id} />
            </Box>
          </Grid>
          <Grid item md={12}>
            <Box mt={2} mb={2}>
              <ChequeSummaryTables userId={data.id} />
            </Box>
          </Grid>
          <Grid item md={12}>
            <Box mt={2} mb={2}>
              <DebitCreditRowDetail
                user={data.id}
                openDebit={this.state.openDebit}
                key={this.state.keyRowDebit}
              />
            </Box>
          </Grid>
          <Grid item md={12}>
            <Box mt={2} mb={2}>
              <DebitCreditListUserPage
                user_id={data.id}
                key={this.state.keyDebit}
                isPerson={true}
                pdfName={`بدهی و طلب ${this.state.data ? this.state.data.fullname : ''}`}
              />
            </Box>
          </Grid>
          <Grid item md={12}>
            <Box mt={2} mb={2}>
              <BankAccountListUserPage user_id={data.id} pdfName={`حساب بانکی ${this.state.data ? this.state.data.fullname : ''}`} />
            </Box>
          </Grid>

          <Grid item md={12}>
            <Box mt={2} mb={2}>
              <PersonAmar user={data.id} amar={data.cheque_amar} />
            </Box>
          </Grid>
        </Grid>
      );
    } else if (pageSelect === PERSON_SELECT_ATTACHMENT && !loading) {
      componentSelect = (
        <PersonListAttachment
          handleBack={() => {
            this.setState({
              pageSelect: PERSON_SELECT_EDIT,
            });
          }}
          user={data}
        />
      );
    }

    return (
      <Wrapper>
        <BreadcrumbsTemp
          title={"ویرایش کاربر"}
          items={[
            {
              title: "ویرایش کاربر ",
              to: "/person/list/",
            },
          ]}
        />

        <Grid container={true}>
          <Grid item xs={12}>
            {loading ? (
              <Loading />
            ) : data === null ? (
              <Wrapper>اطلاعاتی برای نمایش نیست</Wrapper>
            ) : (
              componentSelect
            )}
          </Grid>
        </Grid>
      </Wrapper>
    );
  }
}

export default withRouter(PersonEditPage);
